const getCapitalizedFirstWord = (phrase) => phrase.replace(/^\w/, c => c.toUpperCase());

export default getCapitalizedFirstWord;